import React from 'react';
import { Routes, Route } from "react-router-dom";

import Home from './pages/Home';
import About from './pages/About';
import Shippers from './pages/Shippers';
import Carriers from './pages/Carriers';
import Support from './pages/Support';
import Career from './pages/Career';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Glossary from './pages/Glossary';

// import SEOHead from './component/seo/SEOHead';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/company" element={<About />} />
        <Route path="/shippers" element={<Shippers />} />
        <Route path="/carriers" element={<Carriers />} />
        <Route path="/support" element={<Support />} />
        <Route path="/career" element={<Career />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/glossary" element={<Glossary />} />
      </Routes>
    </div>
  );
}

export default App;